<script setup lang="ts">
import HomeIcon from '@/assets/icons/nav-home.svg?component'
import CalendarIcon from '@/assets/icons/nav-calendar.svg?component'
import ProductIcon from '@/assets/icons/nav-product.svg?component'
import StockIcon from '@/assets/icons/status-error.svg?component'

defineProps<{
  location: string
  isSubscriber: boolean
  hideNavigation?: boolean
  showOutOfStock?: boolean
}>()

const emit = defineEmits<{
  (e: 'goToHome'): void
  (e: 'goToUpcomingOrders'): void
  (e: 'goToOutOfStock'): void
  (e: 'goToYourProducts'): void
}>()
</script>

<template>
  <div
    v-if="!hideNavigation"
    class="MainFooter"
    :class="{ 'MainFooter--with-stock': isSubscriber && showOutOfStock }"
  >
    <div
      class="MainFooter__Action"
      :class="{ 'is-active': location === 'home' }"
      @click="emit('goToHome')"
    >
      <HomeIcon></HomeIcon>
      <span>Home</span>
    </div>
    <div
      v-if="isSubscriber"
      class="MainFooter__Action"
      :class="{ 'is-active': location === 'upcoming-orders' }"
      @click="emit('goToUpcomingOrders')"
    >
      <CalendarIcon></CalendarIcon>
      <span>Upcoming orders</span>
    </div>
    <div
      v-if="isSubscriber && showOutOfStock"
      class="MainFooter__Action"
      :class="{ 'is-active': location === 'out-of-stock' }"
      @click="emit('goToOutOfStock')"
    >
      <StockIcon></StockIcon>
      <span>Out of stock</span>
    </div>
    <div
      v-if="isSubscriber"
      class="MainFooter__Action"
      :class="{ 'is-active': location === 'product-subscriptions' }"
      @click="emit('goToYourProducts')"
    >
      <ProductIcon></ProductIcon>
      <span>Your products</span>
    </div>
  </div>
</template>

<style>
.MainFooter {
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  gap: 16px;
  align-items: first baseline;
  justify-content: center;
  padding-top: 16px;
  padding-bottom: 32px;
  z-index: 1;
  background-color: var(--color-lichen-25);

  @media (--mq-landscape-tablet-and-up) {
    display: none;
  }
}

.MainFooter--with-stock .MainFooter__Action {
  min-width: 72px;
}

.MainFooter__Action {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  min-width: 109px;
  color: var(--color-forest-60);
  font-size: 12px;
  line-height: 1;

  &:hover {
    color: var(--color-forest-100);
    cursor: pointer;
  }

  & svg {
    width: 20px;
    height: 20px;
  }

  &.is-active {
    color: var(--color-forest-100);
  }
}
</style>
